export * from './legal-thesis-header'
